import { useState } from 'react';
import downloadFile from 'helper/downloadFile';

const MESES = [
  'janeiro',
  'fevereiro',
  'março',
  'abril',
  'maio',
  'junho',
  'julho',
  'agosto',
  'setembro',
  'outubro',
  'novembro',
  'dezembro',
];

interface EnsembleData {
  nome: string;
  variavel: string;
  mes: number;
  anos: number[];
  base64Data?: string;
  url?: string;
}

export default function useEnsembleDownload() {
  const [downloadLoading, setDownloadLoading] = useState(false);

  const downloadEnsemble = async (ensembleData: EnsembleData | null) => {
    if (!ensembleData) return;

    const {
      base64Data,
      url,
      variavel,
      mes,
      anos,
    } = ensembleData;

    if (!base64Data && !url) return;

    setDownloadLoading(true);

    try {
      const mesNome = MESES[mes - 1] || `mes_${mes}`;

      const anosRange = anos.length > 1
        ? `${Math.min(...anos)}-${Math.max(...anos)}`
        : anos[0];

      const filename = `ensemble_${variavel}_${mesNome}_${anosRange}.png`;

      if (base64Data) {
        downloadFile(base64Data, filename);
        return;
      }

      if (!url) return;

      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = filename;

      document.body.appendChild(a);
      a.click();
      a.remove();

      URL.revokeObjectURL(blobUrl);
    } finally {
      setDownloadLoading(false);
    }
  };

  return {
    downloadEnsemble,
    downloadLoading,
  };
}
